import DURATIONS from './durations'
import useCustomHover from './useCustomHover'
import useHover, { AnimatedPressable } from './useHover'
import useMultiHover from './useMultiHover'

export { useMultiHover, useCustomHover, AnimatedPressable, DURATIONS }

export default useHover
